function updatePricingInterfacep(prodgirdID,totalprice,sub_price,quart) {
  if ( $('input[name="frequency-selection-' + prodgirdID + '"][value="recurring"]').is(':checked') ) {	
    //show the frequency selector
    var prodPrice = '$'+( totalprice * parseInt(1) / 100 ).toFixed(2);
    var prodSubPrice = '$'+( sub_price * parseInt(1) / 100).toFixed(2);  
    var normal_quart = '$'+((totalprice * parseInt(1) / 100) / parseInt(quart)).toFixed(2) +'/quart';
    var sub_quart = '$'+((sub_price * parseInt(1) / 100) / parseInt(quart)).toFixed(2) +'/quart';
    $('#' + prodgirdID + ' select#interval-selector').show(200);
    $('#' + prodgirdID + ' .double-arrow-select').show(200);
    $('#' + prodgirdID + ' .prod-reg-price-joi').html(prodPrice);
    $('#' + prodgirdID + ' .prod-sub-price-joi').html(prodSubPrice);
    $('#' + prodgirdID + ' .prod-price-joi').html(prodSubPrice);
    if ($('#' + prodgirdID + ' .quart_price').length) {
      $('#' + prodgirdID + ' .quart_price').html(sub_quart);
    }
    if (!$('#' + prodgirdID + ' .add-to-cart-custom').hasClass('sold-out')) {
//       $('#' + prodgirdID + ' .add-to-cart-custom').addClass('redirect_checkout');
//       $('#' + prodgirdID + ' .add-to-cart-custom').text('SUBSCRIBE NOW');
    } else {
//       $('#' + prodgirdID + ' .add-to-cart-custom').removeClass('redirect_checkout');
      $('#' + prodgirdID + ' .quick-add').hide();
//       $('#' + prodgirdID + ' .add-to-cart-custom').text('SOLD OUT');
    }
  } else {
    //show the frequency selector
    $('#' + prodgirdID + ' select#interval-selector').hide(200);
    $('#' + prodgirdID + ' .double-arrow-select').hide(200);
    $('#' + prodgirdID + ' .prod-reg-price-joi').html(prodPrice);
    $('#' + prodgirdID + ' .prod-sub-price-joi').html(prodSubPrice);
    $('#' + prodgirdID + ' .prod-price-joi').html(prodPrice);

    if ($('#' + prodgirdID + ' .quart_price').length) {
      $('#' + prodgirdID + ' .quart_price').html(normal_quart);
    }
    if (!$('#' + prodgirdID + ' .add-to-cart-custom').hasClass('sold-out')) {
//       $('#' + prodgirdID + ' .add-to-cart-custom').removeClass('redirect_checkout');
//       $('#' + prodgirdID + ' .add-to-cart-custom').text('ADD TO CART');
    } else {
//       $('#' + prodgirdID + ' .add-to-cart-custom').removeClass('redirect_checkout');
      $('#' + prodgirdID + ' .quick-add').hide();
//       $('#' + prodgirdID + ' .add-to-cart-custom').text('SOLD OUT');
    }
  }
}

$( document ).ready(function() {
  $('.jmcs-col').each(function(i,v) {      
    var id = $(v).attr('id');
    var price = $(this).attr('data-price');
    var sub_price = $(this).attr('data-sub-price');
    var quart = $(this).attr('data-quart');

    updatePricingInterfacep(id,price,sub_price,quart);
  });

  //---Quickview Handlers---

  //handle the change of quantity
  $('body').on('change', 'input.quantity-selection', function() {
    var id = $(this).closest('.jmcs-col').attr('id');
    var price = $(this).closest('.jmcs-col').attr('data-price');
    var sub_price = $(this).closest('.jmcs-col').attr('data-sub-price');
    var quart = $(this).closest('.jmcs-col').attr('data-quart');
    updatePricingInterfacep(id,price,sub_price,quart);
  });

  //handle the change of recurring
  $('body').on('change', 'input.frequency-selection', function() {
    var id = $(this).closest('.jmcs-col').attr('id');
    $(this).parents('.control-group').find('label').removeClass('active-checked');
    if ($(this).is(':checked')) {
      $(this).parent().addClass('active-checked');
    }
    var price = $(this).closest('.jmcs-col').attr('data-price');
    var sub_price = $(this).closest('.jmcs-col').attr('data-sub-price');
    var quart = $(this).closest('.jmcs-col').attr('data-quart');
    updatePricingInterfacep(id,price,sub_price,quart);
    if($(this).val() == 'one-time'){
      $(this).closest('.product-detail-sec').find('.pack-sizes-wrp').removeClass('subscription-active');
    }else{
      $(this).closest('.product-detail-sec').find('.pack-sizes-wrp').addClass('subscription-active');
    }
    
  });

  //handle click of quantity increase/decrease
  $('body').on('click', 'quantity-selection-button', function(e) {
    var quickviewID = $(this).parent().attr('data-quickviewID');
    var curVal = parseInt($('input#quantity-selection-' + quickviewID).val());
    console.log(quickviewID);
    console.log(curVal);

    if ( $(this).hasClass("minus") ) {
      if (curVal != 1 ) {
        $('input#quantity-selection-' + quickviewID).val(curVal - 1);
        $('input#quantity-selection-' + quickviewID).change();
      } 
    } else if ($(this).hasClass("plus")) {
      $('input#quantity-selection-' + quickviewID).val(curVal + 1);
      $('input#quantity-selection-' + quickviewID).change();
    }
  })

  //handle the add to cart
  $('body').on('click', '.add-to-cart-custom', function(e) {
    var __this = $(this);
    if (!$(this).hasClass('sold-out') && !$(this).hasClass('disabled')) {
      var prodgirdID = $(this).attr('data-prodgirdID');
      var id = $('#' + prodgirdID).attr('data-variant-id');
      var qty = $('#' + prodgirdID).attr('data-qty');
      var selling_plan_id = $('#' + prodgirdID + ' select#interval-selector').children("option:selected").val();
      
      if ($('#' + prodgirdID + ' select#interval-selector').length > 0) {
        var ship_freq = $('#' + prodgirdID + ' select#interval-selector').children("option:selected").attr('data-ship').replace('(s)', 's');
      }
      console.log('id===',id);
      console.log('selling_plan_id==',selling_plan_id);
      console.log('ship_freq ==',ship_freq);
      function callback() {
        setTimeout(function() {
          __this.removeClass( "validate" );
          if (__this.hasClass('redirect_checkout')) {
            setTimeout(function() {
              window.location.href='/checkout';
            }, 2000);
          }
          else {  
            console.log(1233333);
            toggleCart();
          }
        }, 500);
      }
      function validate() {
        setTimeout(function() {
          __this.removeClass( "onclic" );
          __this.addClass("validate");
          callback()
        }, 1100);
      }
      __this.addClass("onclic");
      validate();
      if ($('input[name="frequency-selection-' + prodgirdID + '"][value="recurring"]').is(':checked') || $('#' + prodgirdID).find('select#interval-selector[data-subs-only]').length) {

        //determine the right interval to use

        var viewData = { 
          items : []
        };
        if ($(this).attr('data-bundleprimaryid') != null){
          const primaryProductId = $(this).attr('data-bundleprimaryid');
          const bonusProductId = $(this).attr('data-bundlebonusid');
          const bonusProductPrice = $(this).attr('data-bundlebonusprice');
          const bundleDiscount = $(this).attr('data-bundlediscount');
          const bundleName = $(this).attr('data-bundlename');
          const primaryProductPrice = $(this).attr('data-bundleprimaryprice');
          const bundleUrl = $(this).attr('data-bundleurl');
          console.log("IT's GOING DOWN");
          var primaryData = {};
          var bonusData = {};

          primaryData['quantity'] = parseInt(qty);
          primaryData['id'] = primaryProductId;
          primaryData['selling_plan'] = selling_plan_id;
          primaryData['properties'] = {
            "_recurring": "true",
            "Interval Unit": "week",
            "Subscription": ship_freq,
            "Recurring Discount Amount": "18%",
            "Bundle": bundleName,
            "_bundle_url": bundleUrl,
            "_primary_product_price": primaryProductPrice,
            "_bundle_discount": "5"
          }
          bonusData['quantity'] = parseInt(qty);
          bonusData['id'] = bonusProductId;
          bonusData['properties'] = {
            "Bundle": bundleName,
            "_bonus_product_price": bonusProductPrice,
            "_bundle_discount": bundleDiscount,
            "_bundle_url": bundleUrl,
          }
          viewData.items.push(primaryData);
          viewData.items.push(bonusData);
        } else if ($('#' + prodgirdID).attr('data-preorder') == "true") {
          var jsonData = {};
          jsonData['quantity'] = qty;
          jsonData['id'] = id;
          jsonData['selling_plan'] = selling_plan_id;
          jsonData['properties'] = {
            "_preorder": "Ships when available",
            "_recurring": "true",
            "Interval Unit": "week",
            "Recurring Discount Amount": "18%",
            "Subscription": ship_freq
          }
          viewData.items.push(jsonData);
        } else {
          var jsonData = {};
          jsonData['quantity'] = qty;
          jsonData['id'] = id;
          jsonData['selling_plan'] = selling_plan_id;
          jsonData['properties'] = {
            "_recurring": "true",
            "Interval Unit": "week",
            "Recurring Discount Amount": "18%",
            "Subscription": ship_freq
          }
          viewData.items.push(jsonData);
        }
        console.log(viewData['items']);
        CartJS.addItem({items : viewData['items']}, '', null);
      } else {
        if ($('#' + prodgirdID).attr('data-preorder') == "true") {
          //Add to cart
          CartJS.addItem(
            id, 
            parseInt(qty),
            {
              "_preorder": "Ships when available"
            }
          );
        } else {
          //Add to cart
          CartJS.addItem(
            id, 
            parseInt(qty)
          );

        }
      }
      //open the cart
//       if (!$('input[name="frequency-selection-' + prodgirdID + '"][value="recurring"]').is(':checked')) {
//         toggleCart();
//       }

      //fire taboola script
      _tfa.push({notify: 'event', name: 'Add_to_Bag', id: 1345707});
    }
  });
});
